import React, { ReactElement } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../store/reduxStore";
import { SelectionsState, SelectionStep } from "../store/selections/selectionsTypes";
import Done from "./Done";
import Intro from "./Intro";
import Layouts from "./Layouts";
import Legal from "./Legal";
import Styles from "./Styles";

function Home(): ReactElement {
	const selections = useSelector<RootState, SelectionsState>((store) => store.selections);

	if (selections.step === SelectionStep.Legal) return <Legal />;
	if (selections.step === SelectionStep.Layout) return <Layouts />;
	if (selections.step === SelectionStep.Style) return <Styles />;
	if (selections.step === SelectionStep.Done) return <Done />;

	return <Intro />;
}

export default Home;
